










import { Component } from "vue-property-decorator";
import Header from "@/components/header/ULoginHeader.vue";
import FormEmailEdit from "@/components/forms/FormEmailEdit.vue";
import Footer from "@/components/Footer.vue";
import CheckUserLogin from "@/utils/CheckUserLogin";

@Component({
  components: {
    Header,
    FormEmailEdit,
    Footer,
  },
})
export default class URegisterEmailEdit extends CheckUserLogin {}
